import React from 'react'
import "./home.css"

const Social = () => {
  return (
    <div className='home__social'>

        
        <a href='https://www.linkedin.com/in/alipeiro/' target='_blank' className='home__social-icon'>
             <i class="uil uil-linkedin-alt"></i>
        </a>

        
        <a href='https://github.com/4lipeiro' target='_blank' className='home__social-icon'>
            <i className='uil uil-github-alt'></i>
        </a>

        
        <a href='https://x.com/ali_peiro' target='_blank' className='home__social-icon'>
              <i class="bi bi-twitter-x"></i>
        </a>
        

    </div>
  )
}

export default Social